<template>
  <basic-container>
    <avue-crud
            :option="option"
            :data="data"
            :page.sync="page"
            :search.sync="search"
            ref="crud"
            @row-del="rowDel"
            v-model="form"
            :permission="permissionList"
            @row-update="rowUpdate"
            @row-save="rowSave"
            :before-open="beforeOpen"
            @search-change="searchChange"
            @search-reset="searchReset"
            @refresh-change="refreshChange"
            @selection-change="selectionChange"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            v-if="permission.user_company_add"
            @click="handleCompanyModel">模板下载
        </el-button>
        <el-upload
            v-if="permission.user_company_add"
            :auto-upload="false"
            :on-change='handleImport'
            :show-file-list="false"
            action="#"
            class="filter-item">
          <el-button type="primary" size="small" icon="el-icon-upload2">导入</el-button>
        </el-upload>
        <el-button
            type="success"
            size="small"
            icon="el-icon-success"
            v-if="permission.user_company_edit"
            @click="handleStart('0')">一键开启
        </el-button>
        <el-button
            type="info"
            size="small"
            icon="el-icon-error"
            v-if="permission.user_company_edit"
            @click="handleStart('1')">一键关闭
        </el-button>
        <el-button
                type="danger"
                size="small"
                icon="el-icon-delete"
                v-if="permission.user_company_delete"
                @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot="isStart" slot-scope="scope">
        {{scope.row.isStart === '0' ? '是' : '否'}}
        <el-switch
            active-value="0"
            inactive-value="1"
            @change="switchChange($event, scope.row)"
            v-model="scope.row.isStart">
        </el-switch>
      </template>
      <template slot="isStartForm">
        {{form.isStart === '0' ? '是' : '否'}}
        <el-switch
            active-value="0"
            inactive-value="1"
            v-model="form.isStart">
        </el-switch>
      </template>
      <template slot="isSend" slot-scope="scope">
        {{scope.row.isSend === '0' ? '是' : '否'}}
        <el-switch
            active-value="0"
            inactive-value="1"
            @change="switchChangeSend($event, scope.row)"
            v-model="scope.row.isSend">
        </el-switch>
      </template>
      <template slot="isSendForm">
        {{form.isSend === '0' ? '是' : '否'}}
        <el-switch
            active-value="0"
            inactive-value="1"
            v-model="form.isSend">
        </el-switch>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import mixin from '@/util/mixin'
import { batchIsStart, companyModelExcel, isStart, isSend, isValidTin } from '@/api/user/company'
import { importExcel } from '@/api/common'
import FileSaver from 'file-saver'

export default {
  mixins: [mixin],
  data () {
    const validateTin = (rule, value, callback) => {
      if (!value) {
        return
      }
      const id = this.form.id
      isValidTin(value, id).then(res => {
        const data = res.data
        if (!data) {
          callback(new Error('该纳税人识别号已存在'))
        } else {
          callback()
        }
      })
    }
    return {
      module: 'user/company',
      form: {
        isSend: undefined,
        isStart: undefined,
        id: null,
        name: null,
        tin: null,
        mobile: null,
        rpaUserId: null,
        area: null,
        email1: null,
        email2: null,
        email3: null,
        email4: null,
        email5: null,
        webUrl: null,
        province: null,
        sort: null
      },
      search: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        columnBtn: false,
        indexLabel: '序号',
        labelWidth: 140,
        searchMenuSpan: 5,
        column: [
          {
            label: '单位名称',
            prop: 'name',
            search: true,
            rules: [{
              required: true,
              message: '请输入单位名称'
            }]
          },
          {
            label: '纳税识别号',
            prop: 'tin',
            rules: [{
              required: true,
              validator: validateTin
            }]
          },
          {
            label: '纳税人',
            prop: 'rpaUserId',
            type: 'select',
            filterable: true,
            dicUrl: '/user/rpauser/dict',
            filter: true,
            props: {
              value: 'id',
              label: 'xm'
            }
          },
          {
            label: '接收手机号码',
            prop: 'mobile',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false
          },
          {
            label: '区域',
            prop: 'area',
            search: true,
            type: 'select',
            dicUrl: '/sys/dict/code/area',
            rules: [{
              required: true,
              message: '请选择区域'
            }]
          },
          // {
          //   label: '是否开始申报',
          //   prop: 'isStart',
          //   type: 'radio',
          //   dicData: [{
          //     label: '是',
          //     value: '0'
          //   }, {
          //     label: '否',
          //     value: '1'
          //   }],
          //   rules: [{
          //     required: true
          //   }]
          // },
          {
            label: '纳税是否开始申报',
            prop: 'isStart',
            slot: true,
            formslot: true,
            viewDisplay: false,
            editDisplay: false
          },
          {
            label: '是否开始发送邮件',
            prop: 'isSend',
            slot: true,
            formslot: true,
            viewDisplay: false,
            editDisplay: false
          },
          {
            label: '办税网址',
            prop: 'webUrl',
            hide: true
          },
          {
            label: '省份',
            prop: 'province',
            hide: true
          },
          {
            label: '用友编码',
            prop: 'yyCode',
            hide: true
          },
          {
            label: '序号',
            prop: 'sort',
            hide: true
          },
          {
            label: '邮箱1',
            prop: 'email1',
            hide: true
          },
          {
            label: '邮箱2',
            prop: 'email2',
            hide: true
          },
          {
            label: '邮箱3',
            prop: 'email3',
            hide: true
          },
          {
            label: '邮箱4',
            prop: 'email4',
            hide: true
          },
          {
            label: '邮箱5',
            prop: 'email5',
            hide: true
          }
        ]
      },
      data: []
    }
  },
  computed: {
    permissionList () {
      // return {
      //   addBtn: this.permission.user_company_add ? this.permission.user_company_add : false,
      //   viewBtn: this.permission.user_company_view ? this.permission.user_company_view : false,
      //   delBtn: this.permission.user_company_delete ? this.permission.user_company_delete : false,
      //   editBtn: this.permission.user_company_edit ? this.permission.user_company_edit : false
      // }
      return {
        addBtn: this.permission.user_company_add,
        viewBtn: this.permission.user_company_view,
        delBtn: this.permission.user_company_delete,
        editBtn: this.permission.user_company_edit
      }
    }
  },
  methods: {
    handleStart (status) {
      let msg = '***'
      if (status === '0') {
        msg = '确定开启申报？'
      } else if (status === '1') {
        msg = '确定关闭申报？'
      }
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        batchIsStart(this.ids, status).then(res => {
          if (res.success) {
            this.onLoad(this.page, this.search)
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(function (e) {})
    },
    switchChange ($event, row) {
      let msg = '***'
      if (row.isStart === '0') {
        msg = '确定开启申报？'
      } else if (row.isStart === '1') {
        msg = '确定关闭申报？'
      }
      this.$confirm(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        isStart(row).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            row.isStart = row.isStart === '1' ? '0' : '1'
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(function (e) {
        if (e === 'cancel' || e === 'close') {
          row.isStart = row.isStart === '1' ? '0' : '1'
        }
      })
    },
    switchChangeSend ($event, row) {
      let msg = '***'
      if (row.isSend === '0') {
        msg = '确定开始发送邮件？'
      } else if (row.isSend === '1') {
        msg = '确定关闭发送邮件？'
      }
      this.$confirm(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        isSend(row).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          } else {
            row.isSend = row.isSend === '1' ? '0' : '1'
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(function (e) {
        if (e === 'cancel' || e === 'close') {
          row.isSend = row.isSend === '1' ? '0' : '1'
        }
      })
    },
    beforeOpen (done, type) {
      if (this.$refs.crud) {
        this.$refs.crud.updateDic('rpaUserId')
      }
      done()
    },
    handleCompanyModel () {
      companyModelExcel(this.module).then(res => {
        FileSaver.saveAs(res, '公司导入模板.xlsx')
      })
    },
    handleImport (file) {
      importExcel(this.module, file).then(res => {
        const that = this
        if (res.type === 'application/json') {
          const reader = new FileReader()
          reader.readAsText(res, 'utf-8')
          reader.onload = function () {
            res = JSON.parse(reader.result)
            if (res.success) {
              that.$message({
                type: 'success',
                message: '导入完成!'
              })
              that.onLoad(that.page)
            } else {
              that.$message({
                type: 'error',
                message: res.msg
              })
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: '导入失败'
          })
          FileSaver.saveAs(res, '导入失败数据.xlsx')
        }
      }).catch(e => this.$message({
        type: 'error',
        message: '导入失败'
      })
      )
    }
  }
}
</script>
